module.exports = __webpack_public_path__ + "static/img/jumbotron-pattern.b0024c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/jumbotron-pattern.png
// module id = JJXf
// module chunks = 1